// Third party libraries
import { useState } from 'react';
// Components
import { SiteMenu } from '../site-menu/Site-menu';
// Styles
import styles from './Header.module.css';

export const Header = ({ isLoginBtnShow }) => {
  const [isMenu, toggleMenu] = useState(false);

  return (
    <header className={styles.container}>
      <h1 className={styles.title}> Estimates calculator</h1>
      <SiteMenu
        isMobileOpen={isMenu}
        onBtnClick={toggleMenu}
        isLoginBtnShowed={isLoginBtnShow}
      />

      {/*  <button
        className={styles.mobileBtn}
        onClick={() => toggleMenu(true)}
      >
        <span className="visually-hidden">site menu button</span>
      </button> */}
    </header>
  );
}